import { gsap, EasePack } from "gsap/all";
gsap.registerPlugin(EasePack);
import { Swiper, Navigation } from 'swiper/core';
Swiper.use([Navigation]);

export default () => {
  const r = {};
  const init = () => {
    console.log('init js-card-swiper-wrap');
    r.root = document.querySelector('.js-card-swiper-wrap');
    if (!r.root) {
      return;
    }

    buildYoungSwiper();
  }

  const isPC = window.matchMedia('(min-width: 768px)').matches;
  const swiperOption = {
      init: false,
      loop: true,
      loopAdditionalSlides: 0,
      speed: 400,
      slidesPerView: 'auto',
      centeredSlides : true,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      breakpoints: {
        769: {
          speed: 800,
        }
      },
  }


  const buildYoungSwiper = () => {
    r.container = document.querySelector('._young .swiper-container');
    if (!r.container) {
      return;
    }
    const youngImgContainer = document.querySelector('._young .at-pickup__athletes__container');
    const youngImgItems = document.querySelector('._young .at-pickup__athletes__wrapper').children;
    r.swiper = new Swiper(r.container, swiperOption);
    r.swiper.init();

    if(isPC === true) {
      r.swiper.on('sliderMove', function(){
        let active = r.swiper.activeIndex
        gsap.to(youngImgItems, .1, {scale: .9, skewX:0, ease: EasePack.easeOut, stagger: {from: active, amount: 0}})
      })
      r.swiper.on('touchEnd', function(){
        let active = r.swiper.activeIndex
        gsap.to(youngImgItems, .1, {scale: 1, skewX:0, ease: EasePack.easeOut, stagger: {from: active, amount: 0}})
      })
    } else {
      var start = null;
      youngImgContainer.addEventListener('touchstart',function(event){
        if(event.touches.length === 1){
            //just one finger touched
            start = event.touches.item(0).clientX;
          }else{
            //a second finger hit the screen, abort the touch
            start = null;
        }
      });

      youngImgContainer.addEventListener('touchmove',function(event){
        var offset = 10;
        if(start){
          //the only finger that hit the screen left it
          const end = event.changedTouches.item(0).clientX;

          if(end > start + offset){
            youngImgContainer.classList.remove('is-touch-end');
            youngImgContainer.classList.remove('is-touch-change-left');
            youngImgContainer.classList.add('is-touch-change-right');
          }
          if(end < start - offset ){
            youngImgContainer.classList.remove('is-touch-end');
            youngImgContainer.classList.remove('is-touch-change-right');
            youngImgContainer.classList.add('is-touch-change-left');
          }
        }
      });

      r.swiper.on('touchEnd', function(){
        youngImgContainer.classList.remove('is-touch-start');
        youngImgContainer.classList.remove('is-touch-change-right');
        youngImgContainer.classList.remove('is-touch-change-left');
        youngImgContainer.classList.add('is-touch-end');
      })
    }
  }

  init();

  return {}
}
